// src/components/buyer-leads/LogActivityModal.jsx
import React, { useState } from "react";
import { X } from "lucide-react";
import { toast } from "react-toastify";
import { useStateValue } from "../../context/StateProvider";
import { logBuyerActivity } from "../../utils/firebasefunctions";
import { ACTIVITY_TYPES, newActivity } from "../../utils/buyerActivity";

export default function LogActivityModal({ lead, onClose, onLogged }) {
  const [{ user }] = useStateValue();
  const [type, setType] = useState("Call");
  const [note, setNote] = useState("");
  const [nextFollowUp, setNextFollowUp] = useState(lead.nextFollowUp || "");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    const at = Date.now();
    const activity = newActivity({
      type,
      note,
      by: user?.id || "",
      byName: [user?.firstname, user?.lastname].filter(Boolean).join(" ") || user?.name || "",
      id: `${at}`,
      at,
    });
    const res = await logBuyerActivity(lead.id, activity, { nextFollowUp });
    setBusy(false);
    if (res.success) {
      toast.success("Activity logged");
      onLogged?.();
      onClose();
    } else {
      toast.error(res.error || "Failed to log activity");
    }
  };

  const inputCls =
    "w-full text-sm rounded-lg border border-slate-300 focus:border-[#1E293B] outline-none px-3 py-2";

  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-[60]" onClick={onClose} />
      <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm pointer-events-auto overflow-hidden">
          <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
            <h3 className="text-base font-semibold text-slate-900">Log Activity</h3>
            <button onClick={onClose} className="text-slate-400 hover:text-slate-700 p-1"><X size={18} /></button>
          </div>
          <div className="px-5 py-4 space-y-3">
            <div className="text-sm text-slate-600">
              {lead.contactName}
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-500 mb-1">Type</label>
              <select className={inputCls} value={type} onChange={(e) => setType(e.target.value)}>
                {ACTIVITY_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-500 mb-1">Note</label>
              <textarea rows={3} className={inputCls} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Left a voicemail; sending 3 listings…" />
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-500 mb-1">Next Follow-Up</label>
              <input type="date" className={inputCls} value={nextFollowUp} onChange={(e) => setNextFollowUp(e.target.value)} />
            </div>
          </div>
          <div className="px-5 py-3 border-t border-slate-200 flex justify-end gap-2">
            <button onClick={onClose} className="px-4 py-2 text-sm rounded-lg border border-slate-300 text-slate-600">Cancel</button>
            <button onClick={submit} disabled={busy}
              className="px-5 py-2 text-sm rounded-lg bg-[#1E293B] text-white font-semibold disabled:opacity-60">
              {busy ? "Saving…" : "Log It"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
